// BM-H594 (23 Sep 2026). The Conflict Check chip on the Golden Rule strip.
//
// BL.VEC.002.1412 was cleared and its conflict record was on the drive, yet
// the strip said "Not started". Two things combined:
//   1. the care-pack gate could not find the conflict record (it looked it up
//      by submission_id only), so the gate said nothing; and
//   2. this chip ignored the backend's `pips.conflict_check.cleared: true`
//      whenever `done` was false, and fell through to "Not started".
//
// The backend now finds the record, and this function never discards
// `cleared`. A cleared check whose filing is not yet proven reads as
// "Cleared, filing not confirmed", which is true, instead of green (not true)
// or "Not started" (also not true).

export const CLEARED_FILING_NOT_CONFIRMED = "Cleared, filing not confirmed";

function doneLabel(ccDetail) {
  if (ccDetail === "clear_with_conditions") return "Cleared (conditions)";
  if (ccDetail === "na") return "N/A";
  if (ccDetail === "not_ready") return "Deferred";
  return "Cleared";
}

export function conflictStripStatus({ pips, carePackGates, submission } = {}) {
  const sub = submission || {};
  const g = carePackGates?.gates || {};
  const ccGate = g.conflict_cleared || {};
  const ccDetail = ccGate.detail || "";
  const pipCc = pips?.conflict_check || null;

  // 1. The pipeline says the stage is complete: cleared AND filing evidenced.
  if (pipCc?.done === true) {
    return { status: "complete", label: ccGate.passed ? doneLabel(ccDetail) : "Cleared" };
  }

  // 2. Cleared, but the record is not proven to be on the drive. The
  //    pipeline's answer wins when it is present; the gate's is the fallback
  //    while the pipeline payload is still loading.
  const clearedNotFiled = pipCc
    ? pipCc.cleared === true
    : (ccGate.cleared === true || ccGate.passed === true) && ccGate.filing_confirmed === false;
  if (clearedNotFiled) {
    return { status: "in_progress", label: CLEARED_FILING_NOT_CONFIRMED };
  }

  // 3. Legacy fallbacks, unchanged.
  if (ccGate.passed) return { status: "complete", label: doneLabel(ccDetail) };
  if (ccDetail === "not_needed") return { status: "complete", label: "Not needed" };
  if (ccDetail === "deferred" || ccDetail === "not_ready") return { status: "complete", label: "Deferred" };
  if (ccDetail === "na") return { status: "complete", label: "N/A" };
  if (sub.conflict_check_id) {
    return { status: "in_progress", label: "In review" };
  }
  return { status: "pending", label: "Not started" };
}
